import { styled, StyledComponent } from "@zenchef/styled-system/jsx";

export const Text = styled("span") as StyledComponent<
  "span",
  { as?: React.ElementType }
>;
